export default __webpack_public_path__ + "locales/it/ResetApplicationDialog.json?hash=371f91a1fe1c68b8490c2c3474882ed7";